import { animate, state, style, transition, trigger } from '@angular/animations';

export const SLIDE_UP_DOWN = trigger('slideUpDown', [
  state('void', style({ transform: 'translate3d(0, 100%, 0)' })),
  state('enter', style({ transform: 'translate3d(0,0,0)' })),
  state('leave', style({ transform: 'translate3d(0, 100%, 0)' })),
  transition('* => enter', [
    animate('350ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ transform: 'translate3d(0, 0, 0)' }))
  ]),
  transition('* => leave', [
    animate('350ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ transform: 'translate3d(0, 100%, 0)' }))
  ]),
]);

export const SLIDE_LEFT_RIGHT =
  trigger('leftRight', [
    state('void', style({ transform: 'translate3d(100%, 0, 0)' })),
    state('enter', style({ transform: 'translate3d(0 , 0, 0)' })),
    state('leave', style({ transform: 'translate3d(100%, 0, 0)' })),
    transition('* => enter', [
      animate('350ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ transform: 'translate3d(0, 0, 0)' }))
    ]),
    transition('* => leave', [
      animate('350ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ transform: 'translate3d(100%, 0, 0)' }))
    ]),
  ]);

export const FADEIN_FADEOUT =
  trigger('fadeInOut', [
    state('void', style({ opacity: '0' })),
    state('enter', style({ opacity: '1' })),
    transition('* => *', [animate('200ms ease-in', style({ opacity: '1' }))]),
    transition('* => leave', [animate('200ms ease-in', style({ opacity: '0' }))])
  ]);


